"use strict";
/**
 * Created by aghavni.grigoryan on 7/27/2017.
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Method formatted number values
 * @param value
 * @param symbol
 * @param decimalPartLength
 * @returns {any}
 */
function formatNumber(value, symbol = '', decimalPartLength = 3) {
    if (!value) {
        return value;
    }
    let numberValue = +value;
    if (!isNaN(numberValue)) {
        let valueParts = value.toString().split(".");
        return symbol + valueParts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") + (valueParts[1] ? "." + valueParts[1].slice(0, decimalPartLength) : "");
    }
    else {
        return value;
    }
}
exports.formatNumber = formatNumber;
function formatNumberWithFormatting(value, wholePart = 3, sectionsDelimiter = ',', decimalDelimiter, valueStyleModel, symbol = '', currentLanguageId) {
    const decimalPlaces = valueStyleModel.format.formattingPattern.indexOf('.') !== -1 ?
        valueStyleModel.format.formattingPattern.split('.')[1].length : 0;
    let formattedValue;
    if (decimalPlaces === 0) {
        formattedValue = Math.floor(value).toString();
    }
    else {
        formattedValue = value.toFixed(decimalPlaces);
        formattedValue = formattedValue.match(getDecimalPlacesRegExp(decimalPlaces))[0];
    }
    formattedValue = (decimalDelimiter ? formattedValue.replace('.', decimalDelimiter) : formattedValue)
        .replace(getWholePartRegExp(wholePart, decimalPlaces), '$&' + sectionsDelimiter);
    symbol && (formattedValue = symbol + formattedValue);
    const prefix = valueStyleModel.format.prefixText && valueStyleModel.format.prefixText.getValue(currentLanguageId);
    prefix && (formattedValue = `${prefix} ${formattedValue}`);
    const suffix = valueStyleModel.format.suffixText && valueStyleModel.format.suffixText.getValue(currentLanguageId);
    suffix && (formattedValue = `${formattedValue} ${suffix}`);
    return formattedValue;
}
exports.formatNumberWithFormatting = formatNumberWithFormatting;
function getDecimalPlacesRegExp(decimalPlaces) {
    return new RegExp(`^-?\\d+(?:\\.\\d{0,${decimalPlaces}})?`);
}
exports.getDecimalPlacesRegExp = getDecimalPlacesRegExp;
function getWholePartRegExp(wholePart, decimalPlaces) {
    const re = '\\d(?=(\\d{' + wholePart + '})+' + (decimalPlaces > 0 ? '\\D' : '$') + ')';
    return new RegExp(re, 'g');
}
exports.getWholePartRegExp = getWholePartRegExp;
//# sourceMappingURL=data-formatter.js.map